import EditSceneSlotsOverlay from './EditSceneSlotsOverlay';

export default EditSceneSlotsOverlay;
